<div
  class="servicemesh-vertical-navigation-item-wrapper"
  [class.servicemesh-vertical-navigation-item-has-subtitle]="!!item.subtitle"
  [ngClass]="item.classes?.wrapper"
>
  <div
    class="servicemesh-vertical-navigation-item"
    [ngClass]="{
      'servicemesh-vertical-navigation-item-active': active,
      'servicemesh-vertical-navigation-item-disabled': item.disabled,
      'servicemesh-vertical-navigation-item-active-forced': item.active
    }"
    [matTooltip]="item.tooltip || ''"
  >
    <!-- Icon -->
    @if (item.icon) {
    <mat-icon
      class="servicemesh-vertical-navigation-item-icon"
      [ngClass]="item.classes?.icon"
      [svgIcon]="item.icon"
    ></mat-icon>
    }

    <!-- Title & Subtitle -->
    <div class="servicemesh-vertical-navigation-item-title-wrapper">
      <div class="servicemesh-vertical-navigation-item-title">
        <span [ngClass]="item.classes?.title"> {{ item.title }} </span>
      </div>
      @if (item.subtitle) {
      <div class="servicemesh-vertical-navigation-item-subtitle">
        <span [ngClass]="item.classes?.subtitle"> {{ item.subtitle }} </span>
      </div>
      }
    </div>

    <!-- Badge -->
    @if (item.badge) {
    <div class="servicemesh-vertical-navigation-item-badge">
      <div
        class="servicemesh-vertical-navigation-item-badge-content"
        [ngClass]="item.badge.classes"
      >
        {{ item.badge.title }}
      </div>
    </div>
    }
  </div>
</div>

@if (!skipChildren) {
<div class="servicemesh-vertical-navigation-item-children">
  @for (item of item.children; track trackByFn($index, item)) {
  <!-- Skip the hidden items -->
  @if ((item.hidden && !item.hidden(item)) || !item.hidden) {
  <!-- Basic -->
  @if (item.type === 'basic') {
  <servicemesh-vertical-navigation-basic-item
    [item]="item"
    [name]="name"
  ></servicemesh-vertical-navigation-basic-item>
  }
  <!-- Collapsable -->
  @if (item.type === 'collapsable') {
  <servicemesh-vertical-navigation-collapsable-item
    [item]="item"
    [name]="name"
    [autoCollapse]="autoCollapse"
  ></servicemesh-vertical-navigation-collapsable-item>
  }
  <!-- Divider -->
  @if (item.type === 'divider') {
  <servicemesh-vertical-navigation-divider-item
    [item]="item"
    [name]="name"
  ></servicemesh-vertical-navigation-divider-item>
  }
  <!-- Group -->
  @if (item.type === 'group') {
  <servicemesh-vertical-navigation-group-item
    [item]="item"
    [name]="name"
  ></servicemesh-vertical-navigation-group-item>
  }
  <!-- Spacer -->
  @if (item.type === 'spacer') {
  <servicemesh-vertical-navigation-spacer-item
    [item]="item"
    [name]="name"
  ></servicemesh-vertical-navigation-spacer-item>
  } } }
</div>
}
